(() => {
const $973b254601fecd3f$var$$ = jQuery;
const $973b254601fecd3f$var$_window = $973b254601fecd3f$var$$(window);
const $973b254601fecd3f$var$Menu = {
    $dom: {
        container: $973b254601fecd3f$var$$('#site-navigation'),
        container_flv: $973b254601fecd3f$var$$('.header-my-flv-mobile'),
        menu_toggle: $973b254601fecd3f$var$$('.menu-toggle'),
        menu_toggle_flv: $973b254601fecd3f$var$$('.menu-toggle-flv'),
        body: $973b254601fecd3f$var$$('body'),
        menu: undefined,
        menu_flv: undefined,
        links: undefined,
        links_flv: undefined,
        sub_menus: undefined,
        sub_menus_flv: undefined
    },
    vars: {
        activated_screen_resolution: 1023,
        show_arrows_on_desktop: false
    },
    initDom: function() {
        $973b254601fecd3f$var$Menu.$dom.menu = $973b254601fecd3f$var$Menu.$dom.container.find('ul').eq(0);
        $973b254601fecd3f$var$Menu.$dom.links = $973b254601fecd3f$var$Menu.$dom.menu.find('a');
        $973b254601fecd3f$var$Menu.$dom.sub_menus = $973b254601fecd3f$var$Menu.$dom.menu.find('ul');
        $973b254601fecd3f$var$Menu.$dom.menu_flv = $973b254601fecd3f$var$Menu.$dom.container_flv.find('ul').eq(0);
        $973b254601fecd3f$var$Menu.$dom.links_flv = $973b254601fecd3f$var$Menu.$dom.menu_flv.find('a');
        $973b254601fecd3f$var$Menu.$dom.sub_menus_flv = $973b254601fecd3f$var$Menu.$dom.menu_flv.find('ul');
    },
    appendArrows: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container.find('li.menu-item-has-children');
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find('.arrow-toggle').length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$('<span class="arrow-toggle"><svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69531 16.3964L14.0771 11.0146L8.69531 5.63281" stroke="#1E1E1E" stroke-width="2.15271" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on('click', function() {
                    $973b254601fecd3f$var$$($parent).toggleClass('expandeds');
                    $973b254601fecd3f$var$$($parent).find('> .sub-menu').slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$('.arrow-toggle').remove();
    },
    appendArrowsFlv: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container_flv.find('li.menu-item-has-children');
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find('.arrow-toggle').length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$('<span class="arrow-toggle"><svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69531 16.3964L14.0771 11.0146L8.69531 5.63281" stroke="#1E1E1E" stroke-width="2.15271" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on('click', function() {
                    $973b254601fecd3f$var$$($parent).toggleClass('expandeds');
                    $973b254601fecd3f$var$$($parent).find('> .sub-menu').slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$('.arrow-toggle').remove();
    },
    toggleMenuFlv: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle_flv.on('click', function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle_flv.toggleClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass('menu-active-flv');
            $973b254601fecd3f$var$Menu.$dom.container_flv.toggleClass('toggled');
            if ($973b254601fecd3f$var$Menu.$dom.body.hasClass('page-template-homepage-tpl')) $973b254601fecd3f$var$$('html, body').animate({
                scrollTop: $973b254601fecd3f$var$$('#site-header').offset().top
            }, 400);
            e.stopPropagation();
        });
    },
    toggleMenu: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle.on('click', function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.toggleClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass('menu-active');
            $973b254601fecd3f$var$Menu.$dom.container.toggleClass('toggled');
            if ($973b254601fecd3f$var$Menu.$dom.body.hasClass('page-template-homepage-tpl')) $973b254601fecd3f$var$$('html, body').animate({
                scrollTop: $973b254601fecd3f$var$$('#site-header').offset().top
            }, 400);
            e.stopPropagation();
        });
    },
    closeMenu: function() {
        if ($973b254601fecd3f$var$$(this).attr('href') != '#' && $973b254601fecd3f$var$$(this).attr('href') != '') {
            $973b254601fecd3f$var$Menu.$dom.body.removeClass('menu-active');
            $973b254601fecd3f$var$Menu.$dom.body.removeClass('menu-active-flv');
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.removeClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.menu_toggle_flv.removeClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.container.removeClass('toggled');
            $973b254601fecd3f$var$Menu.$dom.container_flv.removeClass('toggled');
        }
    },
    bindScrollResize: function() {
        $973b254601fecd3f$var$_window.on('resize', function() {
            $973b254601fecd3f$var$Menu.appendArrows();
            $973b254601fecd3f$var$Menu.appendArrowsFlv();
        });
    },
    bindClicks: function() {
        $973b254601fecd3f$var$$(document).on('click', $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links.on('click', $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links_flv.on('click', $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.toggleMenu();
        $973b254601fecd3f$var$Menu.toggleMenuFlv();
        $973b254601fecd3f$var$Menu.$dom.container.find('> div').click(function(e) {
            e.stopPropagation();
        });
        $973b254601fecd3f$var$Menu.$dom.container_flv.find('> div').click(function(e) {
            e.stopPropagation();
        });
    },
    init: function() {
        $973b254601fecd3f$var$Menu.initDom();
        $973b254601fecd3f$var$Menu.appendArrows();
        $973b254601fecd3f$var$Menu.appendArrowsFlv();
        $973b254601fecd3f$var$Menu.bindClicks();
        $973b254601fecd3f$var$Menu.bindScrollResize();
    }
};
var $973b254601fecd3f$export$2e2bcd8739ae039 = $973b254601fecd3f$var$Menu;


const $cb4d446bec07f967$var$$ = jQuery;
const $cb4d446bec07f967$var$_window = $cb4d446bec07f967$var$$(window);
const $cb4d446bec07f967$var$Slider = {
    init: ()=>{
        $cb4d446bec07f967$var$$('.section-intro--slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $cb4d446bec07f967$var$$('.section-intro--slider-prev'),
            nextArrow: $cb4d446bec07f967$var$$('.section-intro--slider-next'),
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 800,
            fade: true,
            pauseOnFocus: true,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false,
                        prevArrow: false,
                        nextArrow: false
                    }
                }
            ]
        });
    }
};
var $cb4d446bec07f967$export$2e2bcd8739ae039 = $cb4d446bec07f967$var$Slider;


const $cb6de554e11ef79b$var$$ = jQuery;
const $cb6de554e11ef79b$var$Theme = {
    dom: {
        shareLink: $cb6de554e11ef79b$var$$(".share-buttons a"),
        smoothScrollLinks: $cb6de554e11ef79b$var$$('a[href*="#"]')
    },
    preventEmptyLink: function() {
        $cb6de554e11ef79b$var$$('a[href="#"], a[href=""]').on("click", function(e) {
            e.preventDefault();
        });
    },
    /**************************************************
    * Share links
    **************************************************/ share: function() {
        $cb6de554e11ef79b$var$$(".share-buttons a").on("click", function(e) {
            if (!$cb6de554e11ef79b$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $cb6de554e11ef79b$var$Theme.PopupCenter($cb6de554e11ef79b$var$$(this).attr("href"), $cb6de554e11ef79b$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function() {
        $cb6de554e11ef79b$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $cb6de554e11ef79b$var$$(this.hash);
                target = target.length ? target : $cb6de554e11ef79b$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $cb6de554e11ef79b$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $cb6de554e11ef79b$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', ()=>{
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function() {
        $cb6de554e11ef79b$var$Theme.share();
        $cb6de554e11ef79b$var$Theme.smooth_scroll();
        $cb6de554e11ef79b$var$Theme.fix_mobile_height();
        $cb6de554e11ef79b$var$Theme.preventEmptyLink();
    }
};
var $cb6de554e11ef79b$export$2e2bcd8739ae039 = $cb6de554e11ef79b$var$Theme;


const $98da60ce08c863db$var$$ = jQuery;
const $98da60ce08c863db$var$Intro = {
    scrollDetect: ()=>{
        const scroll = $98da60ce08c863db$var$$(window).scrollTop();
        const screenHeight = $98da60ce08c863db$var$$(window).innerHeight();
        const header = $98da60ce08c863db$var$$('.page-template-homepage-tpl #site-header');
        const body = $98da60ce08c863db$var$$('body');
        const headerPostion = header.position();
        const animationClass = 'animate-header';
        const finishAnimationClass = 'animate-header-finished';
        if (header && header.length > 0) {
            const activationPostion = scroll + screenHeight / 2.5;
            if (headerPostion.top <= activationPostion) {
                body.addClass(animationClass);
                setTimeout(()=>{
                    if (body.hasClass(animationClass)) body.addClass(finishAnimationClass);
                }, 800);
            } else {
                body.removeClass(finishAnimationClass);
                body.removeClass(animationClass);
            }
        }
    },
    init: ()=>{
        $98da60ce08c863db$var$$(window).on('scroll', function(event) {
            $98da60ce08c863db$var$Intro.scrollDetect();
        });
        $98da60ce08c863db$var$$(document).on('load', function(event) {
            $98da60ce08c863db$var$Intro.scrollDetect();
        });
    }
};
var $98da60ce08c863db$export$2e2bcd8739ae039 = $98da60ce08c863db$var$Intro;


const $ee595bbced94e3de$var$$ = jQuery;
const $ee595bbced94e3de$var$Accordion = {
    init: ()=>{
        $ee595bbced94e3de$var$$(".accordion-title").on("click", function() {
            const parent = $ee595bbced94e3de$var$$(this).parent();
            const content = parent.find(">.accordion-content");
            if (parent && parent.length > 0 && content && content.length > 0) {
                if (parent.hasClass("active")) {
                    content.slideUp("0.4s");
                    parent.removeClass("active");
                } else {
                    content.slideDown("0.4s");
                    parent.addClass("active");
                }
            }
        });
    }
};
var $ee595bbced94e3de$export$2e2bcd8739ae039 = $ee595bbced94e3de$var$Accordion;


(0, $973b254601fecd3f$export$2e2bcd8739ae039).init();
(0, $cb6de554e11ef79b$export$2e2bcd8739ae039).init();
(0, $cb4d446bec07f967$export$2e2bcd8739ae039).init();
(0, $98da60ce08c863db$export$2e2bcd8739ae039).init();
(0, $ee595bbced94e3de$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
